module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-100.1efd96b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-100.jpg
// module id = 3930
// module chunks = 15